import { render, staticRenderFns } from "./MoreProject.vue?vue&type=template&id=3229da0c&scoped=true"
import script from "./MoreProject.vue?vue&type=script&lang=js"
export * from "./MoreProject.vue?vue&type=script&lang=js"
import style0 from "./MoreProject.vue?vue&type=style&index=0&id=3229da0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3229da0c",
  null
  
)

export default component.exports